import styled from 'styled-components';

export const RewardContainerStyled = styled.div`
  .spin_wheel_wrap {
    margin: 30px 0;
  }
`;
